import { Alert, Spinner } from 'react-bootstrap'
import { useAdminUserUsage } from 'api/hooks/use-admin-user'
import { formatTimeAgo } from './user-activity-format'

const UserActivitySummary = ({ userId }) => {
  const { data, isLoading, isError } = useAdminUserUsage({
    userId,
    endpoint: 'activity_summary'
  })

  if (isLoading) return <Alert variant="secondary"><Spinner size="sm" /> Loading activity summary...</Alert>
  if (isError || !data) return null

  const lines = []

  // Last activity
  if (data.last_visit_at) {
    lines.push(`Last visit was ${formatTimeAgo(data.last_visit_at)}.`)
  } else {
    lines.push('No visits recorded.')
  }

  // All-time totals
  const totals = []
  if (data.total_visits > 0) totals.push(`${data.total_visits.toLocaleString()} total visits`)
  if (data.total_page_views > 0) totals.push(`${data.total_page_views.toLocaleString()} page views`)
  if (data.total_events > 0) totals.push(`${data.total_events.toLocaleString()} events`)
  if (totals.length > 0) lines.push(`All-time: ${totals.join(', ')}.`)

  // Content created
  const content = []
  if (data.total_dashboards > 0) content.push(`${data.total_dashboards} views`)
  if (data.total_moles > 0) content.push(`${data.total_moles} samples`)
  if (data.total_exports > 0) content.push(`${data.total_exports} exports`)
  if (data.total_reports > 0) content.push(`${data.total_reports} reports`)
  if (data.total_saved_transactions > 0) content.push(`${data.total_saved_transactions} saved transactions`)
  if (content.length > 0) lines.push(`Created: ${content.join(', ')}.`)

  // Recent activity (last 30 days)
  const recent = []
  if (data.recent_visits > 0) recent.push(`${data.recent_visits} visits`)
  if (data.recent_page_views > 0) recent.push(`${data.recent_page_views} page views`)
  if (data.recent_dashboards > 0) recent.push(`${data.recent_dashboards} new views`)
  if (data.recent_exports > 0) recent.push(`${data.recent_exports} exports`)
  if (data.recent_moles > 0) recent.push(`${data.recent_moles} new samples`)
  if (data.recent_reports > 0) recent.push(`${data.recent_reports} new reports`)
  if (recent.length > 0) {
    lines.push(`Last 30 days: ${recent.join(', ')}.`)
  } else {
    lines.push('No activity in the last 30 days.')
  }

  // Top pages
  if (data.top_pages && data.top_pages.length > 0) {
    lines.push(`Most visited: ${data.top_pages.join(', ')}.`)
  }

  return (
    <Alert variant="" className="mb-4 d-flex align-items-start" style={{ backgroundColor: '#e9ecef', borderColor: '#ced4da', color: '#495057' }}>
      <span style={{ fontSize: '1.5rem', lineHeight: 1, marginRight: '0.75rem' }}>📊</span>
      <div>
        <Alert.Heading style={{ color: '#495057', fontSize: '1rem' }}>Activity Summary</Alert.Heading>
        <p className="mb-0" style={{ fontSize: '0.9rem' }}>{lines.join(' ')}</p>
      </div>
    </Alert>
  )
}

export default UserActivitySummary
